module.exports = __webpack_public_path__ + "static/media/404.200de8e1.png";